import { ForkLiftJobStatus } from "@gtpl/shared-models/warehouse-management";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsEnum } from "class-validator";
export class ForkLiftJobRequest {
    @ApiProperty()
    jobId: number;
    @ApiProperty()
    rackPosition: number;
    
    @ApiProperty({enum:Object.values(ForkLiftJobStatus)})
    @IsNotEmpty()
    @IsEnum(ForkLiftJobStatus)
    status:ForkLiftJobStatus;
    
    
  }